var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 376,
    viewBox: "0 0 417 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_85_20448",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -876,
    y: 0,
    width: 1293,
    height: 376
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -876,
    width: 1293,
    height: 376,
    rx: 24,
    fill: "#270F3A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_85_20448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42188 562C22.4214 426.274 74.8404 276.429 195.524 198.568C226.091 178.847 262.622 167.391 300.029 164.368M300.029 164.368C357.004 159.764 416.013 174.721 459.087 209.832C526.476 264.762 571.595 348.703 535.678 433.597C516.957 477.847 481.188 508.249 430.928 497.799C354.143 481.833 308.083 380.75 299.335 311.39C293.286 263.434 293.724 213.855 300.029 164.368ZM300.029 164.368C322.187 -9.51703 416.799 -182.258 557.078 -279.375",
    stroke: "#FF8C66",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.234f1f57aaa216380cfc3a80bfc1358f.svg";
export { ForwardRef as ReactComponent };